import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, of } from 'rxjs';
import { ZtLoaderService } from 'src/app/shared/components/molecules/zt-loader/zt-loader.service';
import { TokenService } from '../services/token.service';
import { ENDPOINTS } from '../services/base-http.service';

@Injectable()
export class AuthResponseInterceptor implements HttpInterceptor {
    currentRequest!: HttpRequest<any>;

    constructor(
        private tokenService: TokenService,
        private loadingService: ZtLoaderService,
        private router: Router
    ) {}

    logout() {
        this.tokenService.removeToken();
        this.router.navigate(['/login']);
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this.currentRequest = req;

        return next.handle(req).pipe(
            catchError((error: any) => {
                if (
                    error instanceof HttpErrorResponse &&
                    error.status === 401 &&
                    !this.currentRequest.url.includes("/" + ENDPOINTS.TOKEN)
                ) {
                    this.logout();
                    this.loadingService.hideLoader();
                    return EMPTY;
                }

                return next.handle(this.currentRequest);
            })
        );
    }
}
